import React from "react";
import './style.css';
import { Typography } from "@material-ui/core";
import ArrowRightAltIcon from "@material-ui/icons/ArrowRightAlt";
export default function BigCard({ title, subTitle }) {
  return (
    <div className="ct-container">
      <div className="ct-overlay">
        <div className="ct-inner">
          <p className="ct-title">{title}</p>
          <Typography variant="h5" align="center" className="ct-subTitle">
            {subTitle}
          </Typography>
        </div>
      </div>
    </div>
  );
}
